import { withInstall } from '@ll-plus/utils'

import Icon from './src/icon.vue'

export const LlIcon = withInstall(Icon)
export default LlIcon
export * from './src/icon'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlIcon: typeof Icon
  }
}
